import styled from '@emotion/styled';

export const TopAreaContainer = styled.div(() => ({
  display: 'flex',
  padding: '8px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
}));

export const Item = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
}));

export const ItemName = styled.div((props) => ({
  color: props.theme.colors.inactive,
  fontSize: 14,
  fontWeight: 400,
}));

export const ItemValue = styled.div<{ unique?: boolean }>((props) => ({
  fontSize: 14,
  fontWeight: 400,
  fontFamily: props.unique ? props.theme.fonts.secondary : props.theme.fonts.primary,
}));

export const Delimiter = styled.div((props) => ({
  height: 21,
  width: 1,
  background: props.theme.colors.container.tertiary,
}));
